import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { Novedad } from 'src/app/classes/novedad';

@Component({
  selector: 'app-detalle-novedad',
  templateUrl: './detalle-novedad.page.html',
  styleUrls: ['./detalle-novedad.page.scss'],
})
export class DetalleNovedadPage implements OnInit {

  nov=new Novedad;
  constructor(
    private navparams:NavParams,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.nov=this.navparams.get("objeto")
  }

  back(){
    this.modalController.dismiss();
  }
}
